export default {
  blogPosts: []
}
